import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Sparkles, Play } from "lucide-react";

export default function Hero() {
  return (
    <section id="top" className="relative pt-32 md:pt-40 pb-20 container-px overflow-hidden" data-testid="hero-section">
      {/* Grid backdrop */}
      <div aria-hidden className="absolute inset-0 grid-noise opacity-60 pointer-events-none" />
      {/* Vignette gold orb */}
      <div aria-hidden className="absolute -top-40 right-[-10%] h-[600px] w-[600px] rounded-full
                                  bg-[radial-gradient(closest-side,rgba(212,175,55,0.18),transparent_70%)] pointer-events-none" />
      <div aria-hidden className="absolute -bottom-40 left-[-10%] h-[500px] w-[500px] rounded-full
                                  bg-[radial-gradient(closest-side,rgba(184,115,51,0.12),transparent_70%)] pointer-events-none" />

      <div className="relative mx-auto max-w-7xl">
        <div className="flex items-center gap-3 mb-8">
          <span className="inline-flex items-center gap-2 rounded-full border border-gold-500/30 bg-gold-500/[0.06] px-3.5 py-1.5">
            <Sparkles className="h-3.5 w-3.5 text-gold-300" />
            <span className="eyebrow !text-gold-200">Building the Future with AI & Smart Automation</span>
          </span>
        </div>

        <h1 className="font-serif font-medium tracking-tight text-white text-5xl md:text-7xl lg:text-[5.5rem] leading-[1.02] max-w-5xl">
          <span className="block">AI That Works</span>
          <span className="block">for Your <span className="gold-text italic">Business</span>.</span>
        </h1>

        <p className="mt-8 max-w-2xl text-lg md:text-xl text-white/65 font-light leading-relaxed">
          Queue Systems, AI Agents, Smart Automation, Custom Software & Digital Solutions —
          delivered with the polish of a luxury brand and the precision of enterprise engineering.
        </p>

        <div className="mt-10 flex flex-wrap items-center gap-3">
          <Link to="/register" className="pill pill-gold text-base" data-testid="hero-start-demo-btn">
            Start Free Demo <ArrowRight className="h-4 w-4" />
          </Link>
          <a href="#contact" className="pill pill-ghost text-base" data-testid="hero-book-consultation-btn">
            <Play className="h-4 w-4" /> Book Consultation
          </a>
        </div>

        {/* Stats strip */}
        <div className="mt-20 grid grid-cols-2 md:grid-cols-4 gap-px bg-white/8 rounded-2xl overflow-hidden border border-white/10">
          {[
            { k: "120+", v: "Enterprises served" },
            { k: "11", v: "AI Models unified" },
            { k: "99.99%", v: "Uptime SLA" },
            { k: "24/7", v: "Concierge support" },
          ].map((s, i) => (
            <div key={i} className="bg-ink-200 p-6 md:p-8" data-testid={`hero-stat-${i}`}>
              <div className="font-serif text-3xl md:text-4xl gold-text">{s.k}</div>
              <div className="mt-1 text-xs md:text-sm text-white/55">{s.v}</div>
            </div>
          ))}
        </div>

        {/* Logo marquee */}
        <div className="mt-16 overflow-hidden">
          <div className="eyebrow text-center mb-6 text-white/40">Trusted across industries</div>
          <div className="relative">
            <div className="marquee-track flex gap-12 whitespace-nowrap">
              {[...Array(2)].flatMap((_, k) =>
                ["Aurelius Health", "Maison Royale", "Civic Sphere", "OrionPay",
                 "Lumen Hospitality", "Atlas Tourism", "Apex Motors", "BrightMind Edu"]
                  .map((n, i) => (
                    <span key={`${k}-${i}`} className="font-serif text-xl md:text-2xl text-white/30">
                      {n}
                    </span>
                  ))
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
